import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";

function CashfreeEasySplit() {
    const { fetchRequest } = useMyContext();
    const [vendors, setVendors] = useState([]);
    const [formDataError, setFormDataError] = useState({});
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [paymentType, setPaymentType] = useState('bank')


    const baseUrl = process.env.REACT_APP_Baseurl;
    const indexApi = `${baseUrl}/admin/cashfree-easy-split/index`;
    const storeApi = `${baseUrl}/admin/cashfree-easy-split/store`;

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setVendors((prev) => ({ ...prev, [name]: checked }));
        } else {
            setVendors((prev) => ({ ...prev, [name]: value }));
            setFormDataError((prev) => ({
                ...prev,
                ...(name == 'pan_number' ?
                    {
                        pan_number: '',
                        gst_number: ''
                    } :
                    { [name]: "" })
            }));
        }
    };

    const formValidation = () => {
        let valid = true;
        const errors = {};

        if (!vendors?.vendor_name?.trim()) {
            errors.vendor_name = "Vendor name is required";
            valid = false;
        }

        if (!vendors?.vendor_phone) {
            errors.vendor_phone = "Phone number is required";
            valid = false;
        }

        if (!vendors?.vendor_email?.trim()) {
            errors.vendor_email = "Vendor email is required";
            valid = false;
        } else if (!/\S+@\S+\.\S+/.test(vendors.vendor_email)) {
            errors.vendor_email = "Invalid email format";
            valid = false;
        }

        if (!vendors?.vendor_upi_id?.trim() &&
            (!vendors?.vendor_bank_account?.trim() || !vendors?.vendor_ifsc?.trim())) {
            errors.vendor_upi_id = "Either UPI ID or Bank Account with IFSC is required";
            errors.vendor_bank_account = "Either UPI ID or Bank Account with IFSC is required";
            valid = false;
        }

        if (!vendors?.gst_number && !vendors?.pan_number) {
            errors.pan_number = "Please enter either PAN or GST number"
            errors.gst_number = "Please enter either PAN or GST number"
            valid = false
        }

        setFormDataError(errors);
        return valid;
    };

    const handleStore = async () => {

        if (!formValidation()) return;
        setLoading(true);

        try {
            const url = vendors?.id
                ? `${baseUrl}/admin/cashfree-easy-split/update/${vendors?.id}`
                : storeApi;
            const method = vendors?.id ? "PATCH" : "POST";
            vendors.payment_type = paymentType
            const response = await fetchRequest({ method, url, data: vendors });

            if (response?.status) {
                toast.success(response?.message);
                setVendors(response?.data);
                await fetchVendors();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchVendors = async () => {
        try {
            const response = await fetchRequest({ method: "GET", url: indexApi, data: {} });
            if (response?.status) {
                setVendors(response?.data || []);
                setPaymentType(response?.data?.vendor_upi_id ? 'upi' : 'bank')
            }
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    useEffect(() => {
        fetchVendors()
    }, []);

    const formatVendorStatus = (status) => {
        if (!status) return "unknown";

        const map = {
            PENDING: "Pending",
            APPROVED: "Approved",
            REJECTED: "Rejected",
            ACTIVE: "Active",
            INACTIVE: "Inactive",
            BANK_VALIDATION_FAILED: "Bank Validation Failed",
            BANK_ACCOUNT_PENDING: "Bank Account Pending",
            VERIFICATION_IN_PROGRESS: "Verification in Progress",
        };

        return map[status] || status.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
    };



    return (
        <>
            {showOverlay && <Response_Processing />}

            <FormContainer className={`d-flex align-items-center flex-wrap px-md-0 justify-content-between mb-3`}>
                <MessageHeading text={vendors && vendors?.id ? "Edit Vendor" : "Add New Vendor"} noMargin padding />
            </FormContainer>

            {!vendors?.id ?
                (<div className="alert alert-info small">
                    You’ll be using our Cashfree account to receive monetized payments from the subscriptions or PPV plans you create for your videos.
                    To start receiving payments, please register as a vendor on Cashfree by following the steps provided and wait for approval from Cashfree.
                    <br /><strong>Note:</strong> No commission will be charged — only standard transaction fees apply.
                </div>)
                : vendors?.vendor_status !== 'active' ?
                    (
                        <div className="alert alert-info small">
                            <p>
                                Your Cashfree vendor registration is complete. Please wait — your account is currently{" "}
                                <strong>{formatVendorStatus(vendors?.vendor_status)}</strong> with Cashfree. Once approved, you’ll start receiving your subscription and PPV payments directly to your account.
                            </p>
                            <br /><strong>Note:</strong> No commission will be charged — only standard transaction fees apply.
                        </div>
                    ) : vendors?.vendor_status == 'active' ? (
                        <div className="alert alert-success small">
                            Your Cashfree vendor account is active. You’re now ready to receive monetized payments from your subscriptions and PPV plans directly to your account.
                            <br /><strong>Note:</strong> No commission will be charged — only standard transaction fees apply.
                        </div>
                    ) : ''
            }

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageLabel text="Vendor Name" className={`mandatorySimple`} />
                        <AdminCustomInput type="text" name="vendor_name" value={vendors?.vendor_name || ''} onChange={handleInput} placeHolder="Enter vendor name" error={formDataError?.vendor_name} />
                        <MessageLabel text="Vendor Email" className={`mandatorySimple`} />
                        <AdminCustomInput type="email" name="vendor_email" value={vendors?.vendor_email || ''} onChange={handleInput} placeHolder="vendor@example.com" error={formDataError?.vendor_email} />
                        <MessageLabel text="Phone Number" className={'mandatorySimple'} />
                        <AdminCustomInput type="text" name="vendor_phone" value={vendors?.vendor_phone || ''} onChange={handleInput} placeHolder="+91XXXXXXXXXX" error={formDataError?.vendor_phone} />
                        <MessageLabel text="Pan Number" />
                        <AdminCustomInput type="text" name="pan_number" value={vendors?.pan_number || ''} onChange={handleInput} placeHolder="Enter PAN number" error={formDataError?.pan_number} />
                        <MessageLabel text="GST Number" />
                        <AdminCustomInput type="text" name="gst_number" value={vendors?.gst_number || ''} onChange={handleInput} placeHolder="Enter GST number" error={formDataError?.gst_number} />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <FormContainer className="gap-3 mb-3">
                            <AdminCustomButton className={`${paymentType !== 'upi' && 'btn-secondary'}`} saveText="UPI" saveMethod={() => setPaymentType('upi')} />
                            <AdminCustomButton className={`${paymentType !== 'bank' && 'btn-secondary'}`} saveText="Bank Account" saveMethod={() => setPaymentType('bank')} />
                        </FormContainer>
                        {paymentType == 'upi' ?
                            (
                                <div>
                                    <MessageLabel text="UPI ID" />
                                    <AdminCustomInput type="text" name="vendor_upi_id" value={vendors?.vendor_upi_id || ''} onChange={handleInput} placeHolder="vendor@upi" error={formDataError?.vendor_upi_id} />
                                </div>
                            ) : (
                                <div>
                                    <MessageLabel text="Bank Account Number" />
                                    <AdminCustomInput type="text" name="vendor_bank_account" value={vendors?.vendor_bank_account || ''} onChange={handleInput} placeHolder="Account number" error={formDataError?.vendor_bank_account} />
                                    <MessageLabel text="IFSC Code" />
                                    <AdminCustomInput type="text" name="vendor_ifsc" value={vendors?.vendor_ifsc || ''} onChange={handleInput} placeHolder="IFSC code" error={formDataError?.vendor_ifsc} />
                                </div>)
                        }
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={vendors && vendors?.id ? "Update Vendor" : "Add Vendor"} loading={loading} />
            </FormContainer>

        </>
    );
}

export default CashfreeEasySplit;
